import React from 'react';
import DsButton from '../../common/DsButton';

type Props = {
  canView: boolean;
  eventId: string;
  navigate: (path: string) => void;
};

export const buildEventSurveyManagementPath = (eventId: string) =>
  `/admin/workspaces/event-operations/events/${encodeURIComponent(eventId)}/surveys`;

export default function EventSurveyManagementPanel({
  canView,
  eventId,
  navigate,
}: Props) {
  if (!canView || !eventId) return null;

  return (
    <section
      className="event-panel event-survey-panel"
      id="event-survey-section"
      data-section="event-surveys"
      aria-labelledby="event-survey-section-heading"
    >
      <div className="panel-heading">
        <div>
          <h3 id="event-survey-section-heading">アンケート</h3>
        </div>
      </div>
      <p className="muted event-survey-panel__description">
        紙アンケートの取込、回答確認、顧客候補、集計・出力をこのイベント単位で管理します。
      </p>
      <div className="panel-footer">
        <DsButton
          variant="secondary"
          onClick={() => navigate(buildEventSurveyManagementPath(eventId))}
        >
          アンケート管理を開く
        </DsButton>
      </div>
    </section>
  );
}
